import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatPhoneNumber(value: string): string {
  const digits = value.replace(/\D/g, "");
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
}

export function generateSecureId(): string {
  const array = new Uint8Array(16);
  crypto.getRandomValues(array);
  return Array.from(array, (byte) => byte.toString(16).padStart(2, "0")).join("");
}

export function maskEmail(email: string): string {
  const [localPart, domain] = email.split("@");
  if (!localPart || !domain) return email;
  const maskedLocal =
    localPart.length > 2
      ? `${localPart[0]}${"*".repeat(localPart.length - 2)}${localPart[localPart.length - 1]}`
      : localPart;
  return `${maskedLocal}@${domain}`;
}

export function debounce<T extends (...args: Parameters<T>) => ReturnType<T>>(
  func: T,
  wait: number
): (...args: Parameters<T>) => void {
  let timeoutId: ReturnType<typeof setTimeout> | null = null;
  return (...args: Parameters<T>) => {
    if (timeoutId) clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func(...args), wait);
  };
}

export const STORAGE_KEYS = {
  FORM_STATE: "secure_onboarding_form_state",
  FORM_TIMESTAMP: "secure_onboarding_timestamp",
  THEME: "secure_onboarding_theme",
} as const;

export const SECURITY_CONFIG = {
  SESSION_TIMEOUT_MS: 30 * 60 * 1000, // 30 minutes
  MAX_RETRY_ATTEMPTS: 3,
  PASSWORD_MIN_LENGTH: 12,
  SENSITIVE_FIELDS: ["password", "confirmPassword", "securityAnswer"],
} as const;
